import { render, staticRenderFns } from "./ComboboxFaixa.vue?vue&type=template&id=084f254d&scoped=true"
import script from "./ComboboxFaixa.vue?vue&type=script&lang=js"
export * from "./ComboboxFaixa.vue?vue&type=script&lang=js"
import style0 from "./ComboboxFaixa.vue?vue&type=style&index=0&id=084f254d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f254d",
  null
  
)

export default component.exports